import { injectScript } from 'src/utils';

export const salesforceChat = {
  isInitialized: false,
  init: () => {
    if (salesforceChat.isInitialized) {
      return;
    }

    salesforceChat.isInitialized = true;
    injectScript({
      text: `
        function initEmbeddedMessaging() {
          try {
            embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'

            embeddedservice_bootstrap.init(
              '00D500000007bgH',
              'OP_Messaging_Web',
              'https://officepracticum.my.site.com/ESWOPMessagingWeb1715358442926',
              {
                scrt2URL: 'https://officepracticum.my.salesforce-scrt.com',
              }
            );
          } catch (err) {
            console.error('Error loading Embedded Messaging: ', err);
          }
        }
      `,
      onLoad: () => {
        injectScript({
          url: 'https://officepracticum.my.site.com/ESWOPMessagingWeb1715358442926/assets/js/bootstrap.min.js',
          onLoad: () => {
            // @ts-expect-error initEmbeddedMessaging is injected by Salesforce Embedded Messaging bootstrap script
            window.initEmbeddedMessaging();
          },
        });
      },
    });
  },
};
